import YesNo from "../../input/yes-no";

const YesNoFormGenerator = ({ formMap, formState, setFormState }) => {
    function setYesNoValue(key, value) {
        setFormState((fs) => ({ ...fs, [key]: value }));
    }

    return (
        <>
            {Object.keys(formMap).map((section, i) => (
                <div key={i} className="mb-5">
                    <h5>{section}</h5>
                    {formMap[section].map((field, j) => (
                        <div
                            key={j}
                            className="d-flex align-items-center justify-content-between border-bottom py-3 pe-3"
                        >
                            <div className="me-4">{j+1}. {field.question}</div>
                            
                            <YesNo value={formState[field.id]} dataKey={field.id} setValue={setYesNoValue} />
                        </div>
                    ))}
                </div>
            ))}
        </>
    );
};

export default YesNoFormGenerator;
